
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/success",
      function () {
        return require("private-next-pages/login/success.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/success"])
      });
    }
  